// Module
var code = `<ex-mono-occurrence-ecran mono-occurrence-options="vm.monoOccurrenceOptions"> <ex-mono-occurrence-ecran-bas> <ex-card-multi-maitre-details ex-bloc="dai" lbl-titre="LBL_BLC_DAI" multi-occurrence-options="vm.daiMultiOccurrenceOptions"> </ex-card-multi-maitre-details> </ex-mono-occurrence-ecran-bas> </ex-mono-occurrence-ecran>`;
// Exports
module.exports = code;